import React from "react";
import Typewriter from "typewriter-effect";
import "./home.css";

const HomeSection = () => {
  return (
    <div className="home-container">
      <div className="overlay">
        <img src="/images/logo3.png" alt="Logoex" />
        <h2 className="subtitle">Discover the</h2>
        <h1 className="title">Adventure Travel</h1>
      </div>
      <div className="home-content">
        <h2 className="subtitle-content">
          <Typewriter
            options={{
              strings: [
                "Welcome to Explooration – Your Trusted B2B Tourism Partner",
              ],
              autoStart: true,
              loop: true,
              delay: 40,
            }}
          />
        </h2>
      </div>
    </div>
  );
};

export default HomeSection;
